import { render, staticRenderFns } from "./ExitModal.vue?vue&type=template&id=227cd1e4&scoped=true&"
import script from "./ExitModal.vue?vue&type=script&lang=ts&"
export * from "./ExitModal.vue?vue&type=script&lang=ts&"
import style0 from "./ExitModal.vue?vue&type=style&index=0&id=227cd1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227cd1e4",
  null
  
)

export default component.exports